<page-loader *ngIf="!isLoaded"></page-loader>
<div class="app-l-page-wrap home-dashboard-main-container" *ngIf="isLoaded">
    <div class="app-l-dashboard-course">
        <h4 translate>series.chooseHowYouEngage</h4>
        <div class="app-l-st__body">
            <div class="series-type-container">
                <div class="series-type-list">
                    <ng-container *ngFor="let type of seriesTypes">
                        <div
                            *ngIf="checkSeriesEnabled(type)"
                            class="series-type-card"
                            (click)="goToSeries('type', type)">
                            <img
                                class="img-icon"
                                [src]="
                                    './assets/img/series/icons/' + type + '.svg'
                                " />
                            <div class="series-card-header">
                                <!-- <img
                                class="img-icon"
                                [src]="
                                    './assets/img/series/icons/' + type + '.svg'
                                " /> -->
                                <div
                                    class="series-item-card-header-text"
                                    [ngClass]="'header-' + type"
                                    translate>
                                    {{ 'series.seriesTypes.' + type }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="app-l-dashboard-course">
        <h4 translate>series.orPickATopic</h4>

        <div class="app-l-dc__body">
            <div class="app-l-rc__content">
                <ng-container *ngFor="let category of categoryList">
                    <div
                        class="app-l-dc__course-row"
                        *ngIf="shouldShowCategory(category)">
                        <div
                            tabindex="0"
                            class="app-l-dc__c-block"
                            [ngClass]="'category-' + category.Key"
                            (click)="goToSeries('category', category.ID)">
                            <div class="app-l-dc__c-over">
                                <div class="app-l-dc__c-image">
                                    <img
                                        [src]="
                                            './assets/img/series/category/' +
                                            category.Key +
                                            '.svg'
                                        "
                                        alt="" />
                                </div>
                                <div class="app-l-dc__c-content">
                                    <h2 class="app-c-body-text--16-m" translate>
                                        {{
                                            'series.categories.' + category.Key
                                        }}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="categoryList.length === 0">
                    <div class="empty-card">
                        <div class="app-dm-positive-cards" translate>
                            series.noData
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
